import './polyfills'

// something of a fake UUID / GUID; modified a bit from http://stackoverflow.com/a/2117523/2044922
export function guid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export function differentCollections (a, b, id = 'id') {
  return !!a !== !!b || // ie. a is truthy, b is falsy
    a.length !== b.length || // different lengths
    b.some((o, i) => { // compares the two collections to have the same indexes and ids
      return a[i] === undefined || // index doesn't exist on model...
        typeof a[i] !== typeof o || // different type (not an object?)
        a[i][id] !== o[id] // different id
    })
}

export function compareParseInt (a, b, NaNisEqual = true) {
  const pA = parseInt(a, 10)
  const pB = parseInt(b, 10)
  if (NaNisEqual && Number.isNaN(pA) && Number.isNaN(pB)) return true
  return pA === pB
}

export function localStorageAvailable () {
  try {
    let storage = window.localStorage
    const test = '__storage_test__'

    storage.setItem(test, test)
    storage.getItem(test)
    storage.removeItem(test)

    return true
  } catch (e) {
    return false
  }
}

export function storage () {
  if (!window) return false
  if (!localStorageAvailable()) throw new Error('This browser does not support localStorage!')
  return window.localStorage || localStorage
}



// WEBPACK FOOTER //
// ./both/helpers/index.js